import React from "react";
import { Crown } from "lucide-react";
import { useContent } from "@/lib/content";

/**
 * ClassicBadge — small "coroazinha" (little crown) displayed on the top-right
 * of a case thumbnail when `item.is_classic` is true. On hover shows a tooltip
 * with a CMS-editable label (default: "Clássicos Places").
 */
export default function ClassicBadge({ show = false, size = "md", className = "" }) {
  const { home_sections = {} } = useContent();
  const label = home_sections.classic_label || "Clássicos Places";
  if (!show) return null;
  const sz = size === "sm" ? "w-8 h-8" : size === "lg" ? "w-12 h-12" : "w-10 h-10";
  const iconSz = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5";
  return (
    <div
      className={`group/classic absolute top-3 right-3 z-20 ${className}`}
      data-testid="classic-badge"
    >
      <div
        className={`${sz} rounded-full bg-gradient-to-br from-[#FFD700] via-[#FFC300] to-[#B8860B] text-black flex items-center justify-center shadow-lg ring-2 ring-white/70 backdrop-blur-sm cursor-help transition-transform group-hover/classic:scale-110`}
        aria-label={label}
        title={label}
      >
        <Crown className={iconSz} strokeWidth={2.4} fill="currentColor" style={{ color: "#8B6914" }} />
      </div>
      <div
        role="tooltip"
        className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap bg-black text-white text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-full opacity-0 translate-y-1 group-hover/classic:opacity-100 group-hover/classic:translate-y-0 transition-all"
      >
        {label}
      </div>
    </div>
  );
}
